<template>
  <nav class="fixed bottom-0 left-0 right-0 glass-card border-t border-gray-200 dark:border-gray-700 z-40">
    <div class="grid grid-cols-5 gap-1 p-2">
      <router-link
        v-for="item in navItems"
        :key="item.name"
        :to="item.path"
        class="flex flex-col items-center justify-center py-2 px-1 rounded-lg transition-all"
        :class="$route.name === item.name ? 'text-accent' : 'text-gray-500 dark:text-gray-400'"
      >
        <component :is="item.icon" class="w-5 h-5 mb-1" />
        <span class="text-xs">{{ item.label }}</span>
        <div v-if="$route.name === item.name" class="w-1 h-1 bg-accent rounded-full mt-1"></div>
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

// Icon components
const HomeIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 00-1 1h-3a1 1 0 01-1-1v-4a1 1 0 00-1-1H9a1 1 0 00-1 1v4a1 1 0 001 1h3m-6 0a1 1 0 001-1v-4a1 1 0 00-1-1H5a1 1 0 00-1 1v4a1 1 0 001 1h3m6 0V9a1 1 0 00-1 1h-2a1 1 0 01-1-1V5a1 1 0 00-1-1H6a1 1 0 00-1 1v4a1 1 0 001 1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 011 1v2a1 1 0 001 1h3a1 1 0 001-1v-4z"/></svg>' }
const ResearchIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002 2m0 0V9a2 2 0 012-2h2a2 2 0 012-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 002 2h2a2 2 0 002-2m0 0V9a2 2 0 00-2-2h-2a2 2 0 00-2-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 002 2h2a2 2 0 002-2m0 0V9a2 2 0 00-2-2h-2a2 2 0 00-2-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2z"/></svg>' }
const ReportsIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v1a1 1 0 001 1h4a1 1 0 001-1v-1m3-2V8a2 2 0 00-2-2H8a2 2 0 00-2 2v6m0 4V8a2 2 0 002 2h4a2 2 0 002-2m0 0h2m-6 4h.01M9 17h.01"/></svg>' }
const TasksIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18z"/><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18z"/></svg>' }
const UserIcon = { template: '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/></svg>' }

const navItems = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    label: 'Home',
    icon: HomeIcon
  },
  {
    name: 'Research',
    path: '/research',
    label: 'Research',
    icon: ResearchIcon
  },
  {
    name: 'Reports',
    path: '/reports',
    label: 'Reports',
    icon: ReportsIcon
  },
  {
    name: 'Tasks',
    path: '/tasks',
    label: 'Tasks',
    icon: TasksIcon
  },
  {
    name: 'Account',
    path: '/account',
    label: 'Account',
    icon: UserIcon
  }
]
</script>

<style scoped>
.router-link-active {
  color: var(--accent);
}
</style>
